@import '../../../globals/main.scss';

pn-profile-selector-option {
  display: flex;
  width: 100%;
  border-bottom: 1px solid $gray200;
  padding: 1.2rem 0;
  &:first-of-type {
    margin-top: 2.4rem;
  }
  &:last-of-type {
    border-bottom: 0;
    padding-bottom: 0;
    .profileselectoroption {
      padding-bottom: 0;
    }
  }
}

.profileselectoroption {
  display: flex;
  width: 100%;
  padding: 1.2rem 0;
  pn-icon {
    align-self: center;
    position: relative;
    transform: translateX(-1rem);
    transition: transform 0.25s linear;
  }
  text-decoration: none;
  &:hover,
  &:focus,
  &:active {
    .profileselectoroption-name {
      text-decoration: underline;
    }
    pn-icon {
      transform: none;
      transition-timing-function: ease;
    }
  }
}

.profileselectoroption-text {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.profileselectoroption-title {
  font-size: 1em;
  color: $blue700;
  font-weight: 700;
}

.profileselectoroption-description {
  font-size: 0.75em;
  color: $gray700;
  font-weight: normal;
}
